export default __webpack_public_path__ + "static/media/portrait--dan.bcf45231.jpg";